import API from '@/api'

export default {
  namespaced: true,
  state: {
    data: [],
    loaded: false,
  },
  mutations: {
    saveData(state, data) {
      state.data = data;
    },
    load(state) {
      state.loaded = true;
    }
  },
  actions: {
    updateData(context, payload) {
      return API.TexturesAPI.selectAll().then(res => {
        let data = res.data.map(el => {
          return {
            key: el.id,
            label: el.name
          }
        });
        context.commit('saveData', data);
        context.commit('load');
      });

    },
  },
  getters: {
    data(state) {
      return state.data;
    },
    isLoaded(state) {
      return state.loaded;
    },
  }
}
